(function () {
    $(document).ready(function () {
        let hash = $(location).attr('hash');
        if (!hash) {
            return false;
        }

        let marginTop = 150;
        let screenWidth = $(this).width();
        if (screenWidth < 768) {
            marginTop = 115;
        }
        $(this).scrollTop(0);
        $('html, body').animate({
            scrollTop: $($(hash)).offset().top - marginTop
        }, 500);

        $("#nav_bar").find('.scroll_link').click(function (e) {
            scrollAnimation(this.hash);
            // location.hash = this.hash;
            return true;
        });

        function scrollAnimation(nameHash) {
            $('html,body').animate({
                scrollTop: $($(nameHash)).offset().top - marginTop
            }, 500);
        }
    });
})();